import { useCallback } from 'react'
import { useI18n, type UseI18n } from '../../core/i18n/useI18n'

/**
 * Traduz textos vindos de configurações declarativas legadas.
 *
 * Esses textos não nascem dentro de um componente React (colunas, opções, schemas
 * e metadados de ResourceConfig), portanto não podem chamar `useI18n` na origem.
 * O consumidor traduz no momento da renderização, o que também garante reação à
 * troca de idioma sem remontar a rota.
 */
export function translateDeclarativeText(t: UseI18n['t'], value: string): string {
  if (!value || value === '—') return value
  const key = `declarative.${value}`
  const translated = t(key)
  return translated === key ? value : translated
}

export function useDeclarativeText(): (value: string) => string {
  const { t } = useI18n()
  return useCallback((value: string) => translateDeclarativeText(t, value), [t])
}
